import { LucideIcon } from "lucide-react";
import { memo } from "react";

import { Card, CardContent } from "@/common/components/ui/card";

export interface StatusCardData {
  id?: string;
  title: string;
  count?: string | number | null;
  icon: LucideIcon;
  className: string;
}

interface StatusCardsProps {
  cards: StatusCardData[];
  activeStatusId?: string;
  onStatusClick: (statusId: string) => void;
  className?: string;
}

export const StatusCards = memo(function StatusCards({
  cards,
  activeStatusId,
  onStatusClick,
  className,
}: StatusCardsProps) {
  return (
    <div className={className}>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-2 md:gap-4 mb-6">
        {cards.map((stat) => {
          const Icon = stat.icon;
          const isActive = activeStatusId === stat.id;
          return (
            <button
              onClick={() => onStatusClick(stat.id ?? "")}
              key={stat.id ?? ""}
              aria-pressed={isActive}
            >
              <Card
                className={`cursor-pointer transition-shadow h-28 md:h-32 md:p-3 p-4 overflow-hidden ${
                  isActive ? "shadow-md ring-1 ring-zinc-200 border-gray-400" : "hover:shadow-md"
                }`}
              >
                <CardContent className="h-full text-center flex flex-col justify-between">
                  <div
                    className={`p-2 rounded-full mx-auto mb-2 w-8 h-8 flex items-center justify-center ${stat.className}`}
                  >
                    <Icon className="h-4 w-4" />
                  </div>
                  <p className="text-[0.625rem] md:text-xs font-normal text-Text-secondary mb-1 leading-3 md:leading-4">
                    {stat.title}
                  </p>
                  <p className="text-md md:text-lg font-bold text-zinc-800 leading-4 md:leading-6">
                    {stat.count || "-"}
                  </p>
                </CardContent>
              </Card>
            </button>
          );
        })}
      </div>
    </div>
  );
});
